import { isFirefox } from 'react-device-detect';

function value4query(key, value) {
    if (value === null || value === undefined) {
        return '';
    }

    return value; //encodeURIComponent(value);
}

export async function serverFetch(apiBaseUrl, warehouseCode, address, options, signal) {
    options = options || {};

    if (!apiBaseUrl) {
        console.error('ApiBaseUrl must be specified');
    }

    let url = new URL(`${apiBaseUrl}/api/${address}`);

    Object.keys(options.queryParams || {}).forEach((key) => {
        if (Array.isArray(options.queryParams[key])) {
            options.queryParams[key].map((value) => url.searchParams.append(key, value4query(key, value)));
        } else {
            url.searchParams.append(key, value4query(key, options.queryParams[key]));
        }
    });

    let init = {
        ...options,
        headers: options.body ? new Headers() : new Headers({ accept: 'application/json', 'Content-Type': 'application/json-patch+json' }),
    };

    init.headers.append('Authorization', `Bearer ${window.accessToken}`);

    if (warehouseCode) init.headers.append('WarehouseCode', warehouseCode);

    if (options.bodyData != null) {
        init.body = JSON.stringify(options.bodyData);
    }

    if (options.headers) {
        Object.keys(options.headers).forEach((key) => {
            init.headers.append(key, options.headers[key]);
        });
    }

    if (signal) init.signal = signal;

    let tokenRefreshed = false;

    let response;
    do {
        try {
            response = await fetch(url, init);

            if (!tokenRefreshed && response.status === 401 && (isFirefox || !!response.headers.get('www-authenticate'))) {
                if (address !== 'auth/signin' && address !== 'auth/mysignin') {
                    response = await tryRefreshAuthToken(apiBaseUrl);

                    if (response.ok) {
                        tokenRefreshed = true;
                        init.headers.set('Authorization', `Bearer ${window.accessToken}`); // TODO replace with proper storage
                    }
                }
            } else {
                tokenRefreshed = false;
            }
        } catch (exc) {
            console.log('error fetch', exc);
            console.error(exc);
            throw new Error('Error parsing response body');
        }
    } while (tokenRefreshed);

    if (response.ok && response.status === 204) {
        return;
    }

    let responseContentPromise;
    if (!response.ok || options.rawResponse) {
        responseContentPromise = response.text();
    } else if (options.download || options.blob) {
        responseContentPromise = response.blob();
    } else {
        responseContentPromise = response.json();
    }

    let content;
    try {
        content = await responseContentPromise;
    } catch (exc) {
        console.error(exc);
        throw new Error('Error parsing response body');
    }

    if (response.ok) {
        return content;
    }

    if (!content) {
        content = {
            status: response.status,
            message: response.statusText,
        };
    } else if (typeof content == 'string') {
        try {
            content = JSON.parse(content);
        } catch {
            // ignore
        }
    }

    throw content;
}

async function tryRefreshAuthToken(apiBaseUrl) {
    let url = new URL(`${apiBaseUrl}/api/auth/refreshtoken`);

    let init = {
        method: 'POST',
        body: JSON.stringify({ token: localStorage.getItem('refreshToken') }),
        headers: new Headers({
            accept: 'application/json',
            'Content-Type': 'application/json-patch+json',
        }),
    };

    try {
        let response = await fetch(url, init);

        if (response.ok) {
            var content = await response.json();

            window.accessToken = content.accessToken; // TODO replace with proper storage
            localStorage.setItem('refreshToken', content.refreshToken); // TODO replace with proper storage
        }
        return response; // TODO replace with proper storage
    } catch (ex) {
        throw ex;
    }
}
